import arcgisConfig from "@arcgis/core/config"
import type { RequestInterceptor as typesRequestInterceptor } from "@arcgis/core/request/types";

type RequestInterceptor = typesRequestInterceptor & {
  id: string | number
}

export function addInterceptor(input: RequestInterceptor) {
  // prevent the intercetor from being added multiple times
  const interceptors = arcgisConfig.request.interceptors
  if (!interceptors) return

  const ex = interceptors.findIndex(
    (i): i is RequestInterceptor => "id" in i && i.id === input.id
  )
  if (ex !== -1) {
    interceptors.splice(ex, 1)
  }
  interceptors.push(input)
}

// This makes certain layers load much faster, due to the arcgis client not preloading the entire layer upfront
// addInterceptor({
//   id: "increase-count-for-geomap-matrikkel-points-layer",
//   urls: new RegExp(
//     "https://services.geodataonline.no/arcgis/rest/services/Geomap_UTM33_EUREF89/GeomapMatrikkel/FeatureServer/3*",
//     "i"
//   ),
//   after(res) {
//     if (res.requestOptions?.query.returnCountOnly) {
//       res.data.count = 999999
//     }
//   }
// })
